module.exports = window.evite.urls;